import { getLink } from '@helpers/env'
import classNames from 'classnames'
import styles from './styles.module.scss'

const GDPR_DATA = {
  gdpr_accepts_marketing: 'Don&#39;t send me offers and updates from Spoke.',
  gdpr_terms_url: '/pages/terms',
  gdpr_privacy_url: getLink('/pages/privacy')
}

type FieldsLegalTextProps = {
  widthStyle?: string
  extraContent?: React.ReactNode
}

export const FieldsLegalText = ({
  widthStyle,
  extraContent
}: FieldsLegalTextProps) => {
  const classes = classNames(styles.gdprFields, {
    [styles.gdprFieldsNarrow]: widthStyle === 'narrow',
    [styles.gdprFieldsHidden]: widthStyle === 'hidden'
  })

  return (
    <div className={classes}>
      {extraContent && extraContent}
      <p className={styles.gdprTerms}>
        Thrill-seeker? See the{' '}
        <a
          href={getLink(GDPR_DATA.gdpr_terms_url)}
          className={styles.gdprLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          T&Cs
        </a>{' '}
        and{' '}
        <a
          href={getLink(GDPR_DATA.gdpr_privacy_url)}
          className={styles.gdprLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          privacy statement.
        </a>
      </p>
    </div>
  )
}
